import { Component, ViewContainerRef, OnInit, OnDestroy, HostListener, Inject, ViewRef, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthServices, AppServices } from '@services';

//For Modal Pages
import { LockComponent } from "./+auth/lock/lock.component";
import { MatDialog } from '@angular/material/dialog';
import { EnviromentServices } from '@services/app/enviroment.services';
import { environment as env } from 'environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;
    ActiveRoutes = [];

    constructor(
        private router: Router,
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AppServices') private _appServices: AppServices,
        private _dialogService: MatDialog,
        private AppEnv: EnviromentServices) {

        // this.toastr.setRootViewContainerRef(vRef);

        //On Authorized Refresh Session to Add Lock and Logout timer when User is Inactive
        this._authServices.onAuthorized.subscribe(() => { this._appServices.RefreshSession() });

        // TODO : What about unsaved work from users?????
        //WARNING : Messages Before Session is going to Locked or Logged out 
        this._appServices.onSessionToBeLocked.subscribe(function (_RemainingTime) {
            // this.toastr.info('System will locked in ' + _RemainingTime );
            console.log("show a message that is going to be Locked in " + _RemainingTime)
        });
        this._appServices.onSessionToBeLogOut.subscribe(function (_RemainingTime) {
            // this.toastr.info('System will logged out in ' + _RemainingTime );
            console.log("show a message that is going to be Logged out in " + _RemainingTime)
        });

        this._appServices.onLockSession.subscribe(() => {

            const _dialog = this._dialogService.open(LockComponent, {
                disableClose: true,
                panelClass: 'csp-mat-full-screen-dialog',
            });
            _dialog.componentInstance.onUnLockRequest.subscribe(() => { _dialog.close() });
            _dialog.componentInstance.onLogOutRequest.subscribe(() => {

                _appServices.Logout();
                _dialog.close();
            });

            _appServices.onLogoutSession.subscribe(() => { _dialog.close() });

        });




    }

    //On Every Click on the Entire Application to Refresh Session Timeout
    @HostListener('click') onClick() { this._appServices.RefreshSession() }


    // //On Windows Resize Get the New Window Sizes
    // @HostListener('window:resize', ['$event'])
    // getScreenSize(event?) { console.log(window.innerWidth, window.innerHeight);}
    // //Add this to constructor // this.getScreenSize();
    // //End of Windows Resize

    ngOnInit() {


        const getEnvData = this.AppEnv.getEnv();
        if (getEnvData.mode.toLocaleLowerCase() === 'appauditorsregistration'){
            this.router.navigate(['register'])
        } 

        env.authURL = getEnvData.authURL;
        //console.log(getEnvData)

        this.subscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => window.scrollTo(0, 0));

        // console.log("APP Component Loaded")

        // this.router.events.subscribe(async routerEvent => {
        //     // if (routerEvent instanceof NavigationStart) { }
        //     this.ActiveRoutes = this.router.config;
        //     console.log(this.ActiveRoutes)
        //   });

        //TODO : Pre-Running Operations before launching Application
        // 1. Load Dictionary Files for Translation

        // 2. Check if Session has expired
        // Used this mainly on Reload Application
        this._appServices.RefreshSession();

        // 3. Apply Application Settings 
        // if Stored in Local Storage otherwise use the App Default Settings
        this._appServices.applyAppSettings();

        
        
        

    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }



}